const STATE_TTL_MS = 30 * 60 * 1000;
const PREFIX = 'scroll-state:';

export function useScrollState() {
  function save(key, state) {
    try {
      sessionStorage.setItem(
        PREFIX + key,
        JSON.stringify({ ...state, timestamp: Date.now() })
      );
    } catch (e) {
      console.warn('Could not save scroll state:', e);
    }
  }

  function restore(key) {
    try {
      const raw = sessionStorage.getItem(PREFIX + key);
      if (!raw) return null;
      const state = JSON.parse(raw);
      if (Date.now() - state.timestamp > STATE_TTL_MS) {
        clear(key);
        return null;
      }
      return state;
    } catch {
      return null;
    }
  }

  function clear(key) {
    sessionStorage.removeItem(PREFIX + key);
  }

  return { save, restore, clear };
}
